import { render, staticRenderFns } from "./ExhibitCard.vue?vue&type=template&id=fc892336&scoped=true&"
import script from "./ExhibitCard.vue?vue&type=script&lang=js&"
export * from "./ExhibitCard.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitCard.vue?vue&type=style&index=0&id=fc892336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc892336",
  null
  
)

export default component.exports